import React from 'react';
import { useParallax } from 'react-scroll-parallax';

const TacoTuesdaySpecials: React.FC = () => {
  // 1) PRAWNS
  const prawnTopRef = useParallax<HTMLDivElement>({ rotate: [0, 20] });
  const prawnBottomRef = useParallax<HTMLDivElement>({ rotate: [20, 0] });

  // 2) FISH
  const fishLeftRef = useParallax<HTMLDivElement>({ translateX: [20, 0] });
  const fishBottomRef = useParallax<HTMLDivElement>({ translateX: [40, 0] });

  // 3) BUBBLES
  const bubblesRef = useParallax<HTMLDivElement>({ translateY: [0, -100] });

  // 4) OCTOPUS
  const octopusRef = useParallax<HTMLDivElement>({ rotate: [-2, 2] });

  return (
    <div className="relative space-y-6 mt-12 overflow-visible w-full pb-[15vh] md:pb-[30vh]">
      {/* BACKGROUND / ACCENTS */}
      <div className="pointer-events-none absolute inset-0 z-0">
        {/* 1) Prawns */}
        <div
          ref={prawnTopRef.ref}
          className="
            absolute 
            w-[8vw] 
            top-10 
            right-1/3 
            translate-x-1/2
          "
        >
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/blue_prawn.webp"
            alt="Blue Prawn"
            className="rotate-[140deg]"
          />
        </div>

        <div
          ref={prawnBottomRef.ref}
          className="
            absolute 
            w-[8vw]
            bottom-[12.5%]
            left-1/3 
            -translate-x-1/2
          "
        >
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/blue_prawn.webp"
            alt="Blue Prawn"
            className="rotate-[140deg]"
          />
        </div>

        {/* 2) Two large fish images */}
        <div
          ref={fishLeftRef.ref}
          className="
            absolute 
            w-[50vw]
            top-[25%]
            -left-[30%]
            -translate-y-1/2
            opacity-80
          "
        >
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/blue_fish.webp"
            alt="Blue Fish Left"
            className="scale-x-[-1]"
          />
        </div>
        <div
          ref={fishBottomRef.ref}
          className="
            absolute 
            w-[50vw]
            -bottom-[20vh]
            right-1/2
            translate-x-1/2
            translate-y-1/2
            opacity-80
          "
        >
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/blue_fish.webp"
            alt="Blue Fish Bottom"
            className="scale-x-[-1] "
          />
        </div>

        {/* 3) Bubbles pinned near bottom-center */}
        <div
          ref={bubblesRef.ref}
          className="
            absolute 
            w-[6vw]
            bottom-0
            left-[12.5%] 
            -translate-x-1/2
          "
        >
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/blue_bubbles.webp"
            alt="Blue Bubbles"
          />
        </div>

        {/* 4) Octopus off the right side, centered vertically */}
        <div
          ref={octopusRef.ref}
          className="
            absolute 
            w-[40vw]
            top-1/2
            -translate-y-1/2
            right-[-10%]
          "
        >
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/blue_octopus.webp"
            alt="Blue Octopus"
          />
        </div>
      </div>

      {/* FOREGROUND CONTENT (z-10) */}
      <div className="relative z-10">
        {/* Ribbon + Heading */}
        <div className="relative flex justify-center items-center pt-20 pb-10">
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/ribbon_highlight.webp"
            alt="Left Ribbon"
            className="
              relative
              mr-4
              transform 
              scale-x-[-1]
              w-[18vw]
              md:w-[8vw]
            "
          />
          <h2 className="text-3xl md:text-5xl xl:text-7xl text-maroon text-center font-charles !leading-tight">
            TACO
            <br />
            TUESDAY
            <br />
            SPECIALS
          </h2>
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/ribbon_highlight.webp"
            alt="Right Ribbon"
            className="
              relative
              ml-4
              w-[18vw]
              md:w-[8vw]
            "
          />
        </div>

        {/* Paragraph 1 */}
        <p className="text-maroon font-prosto text-md xl:text-2xl mb-12 text-center px-12">
          Famous Baja Tacos at special prices.
          <br className="hidden md:block" />
          Choose from Fish, Shrimp, or Octopus
        </p>

        {/* Paragraph 2 */}
        <p className="text-maroon font-prosto text-md xl:text-2xl text-center">
          Fish Taco — $6 each
          <br />
          Shrimp Taco — $7 each
          <br />
          Octopus Taco — $8 each
        </p>
      </div>
    </div>
  );
};

export default TacoTuesdaySpecials;
